module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrap"
  }, [_c('SectionLabel'), _vm._v(" "), _c('SectionHome', {
    attrs: {
      "id": "home",
      "data-id": "0",
      "visibilityChanged": _vm.visibilityChanged
    }
  }, [_c('RevealBlock', {
    attrs: {
      "classList": "reveal-margin reveal-top reveal-center",
      "imageSrc": "grigio.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('h1', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("message.home_section_1_title")) + "\n      ")]), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.home_section_1_text_1'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cta-ext",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$t('message.home_section_1_cta-link'),
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.home_section_1_cta'))
    }
  })])]), _vm._v(" "), _c('News', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000",
      "toggleOpenOverlay": _vm.toggleOpenOverlay
    }
  })], 1), _vm._v(" "), _c('SectionHome', {
    attrs: {
      "id": "who-we-are",
      "data-id": "1",
      "visibilityChanged": _vm.visibilityChanged
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('h2', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("message.home_section_2_title")) + "\n      ")]), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.home_section_2_text_1'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "with-margin",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.home_section_2_text_2'))
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.home_section_2_text_3'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "certifications--wrap",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/recyclass.png"),
      "alt": "RecyClass"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.$t('message.image-second-life-01'),
      "alt": "Plastica Seconda Vita"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.$t('message.image-second-life-02'),
      "alt": "Plastica Seconda Vita"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "certifications--wrap-text",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.home_section_2-image-desc'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "certifications--wrap wide--row",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo-pre.jpg"),
      "alt": "Plastic recyclers europe"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "certifications--wrap wide--row",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/conip.png"),
      "alt": "Conip Logo"
    }
  })]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('h2', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("message.home_section_2_text_4")) + "\n        ")]), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.home_section_2_text_5'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "certifications--wrap full--row",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/applications.png"),
      "alt": "Plastic recyclers europe"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "video-wrap"
  }, [_c('div', {
    staticClass: "embed-container",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.home_video_link'))
    }
  })])]), _vm._v(" "), _c('RevealBlock', {
    attrs: {
      "classList": "reveal-margin",
      "imageSrc": "00_2x.jpg"
    }
  })], 1), _vm._v(" "), _c('SectionHome', {
    attrs: {
      "id": "our-technology",
      "data-id": "2",
      "visibilityChanged": _vm.visibilityChanged
    }
  }, [_c('RevealBlock', {
    attrs: {
      "classList": "reveal-margin reveal-top reveal-center",
      "imageSrc": "our-tech-hero.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('h2', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("message.home_section_3_title")) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "quote",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.home_section_3_text_1'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "two-cols",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.home_section_3_text_2'))
    }
  })]), _vm._v(" "), _c('SliderCarousel')], 1), _vm._v(" "), _c('SectionHome', {
    attrs: {
      "id": "our-plant",
      "data-id": "3",
      "visibilityChanged": _vm.visibilityChanged
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('h2', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.home_section_4_title'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "quote",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.home_section_4_text_1'))
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.home_section_4_text_2'))
    }
  })])]), _vm._v(" "), _c('OverlayNews', {
    attrs: {
      "isOpenOverlay": _vm.isOpenOverlay,
      "indexNews": _vm.indexNews
    },
    on: {
      "toggleOpenOverlay": _vm.toggleOpenOverlay
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a48fbea","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 338
// module chunks = 0